import { connect } from 'react-redux';

import generateOffersBreadCrumbs from 'components/Offers/utils/generate-offers-breadcrumbs';
import { getPageTitle } from 'redux/modules/search-and-browse/selectors';

import OffersHeader from './OffersHeader';

export default connect(state => ({
  breadcrumbs: generateOffersBreadCrumbs(state),
  navigation: state.offers.relatedNavigation,
  title: getPageTitle(state),
}))(OffersHeader);
